
import qs from 'qs'
import {Dialog, Toast} from 'vant'
import {vBeforeClose} from "@/utils/tool";
import {trim} from "lodash/string";

export default {
  name: 'Terminal',

  inject: ['reload'],
  data() {
    return {
      data: [],
      titelData: [],
      loading: false,
      index: 0,
      dialogShow: false,
      groupName: '',
      show: false,
      overlayShow: false,
      showLoading: true,
      msg:this.$t('append_field.loadingb'),
      title:this.$t('append_field.create_terminal_group'),
    }
  },

  mounted() {
    document.title = this.$t('append_field.terminal_management')
    this.handleResize();
    window.addEventListener('resize', this.handleResize);

    this.showLoading=true
    this.getData()

  },
  methods: {
    vBeforeClose,


    handleResize() {
      // 获取底部导航栏元素
      const tabbar = document.querySelector('.van-tabbar')
      tabbar.style.display = 'none'
    },
    truncatedName(fullName) {
      // 截断名称并确保括号内容完整显示
      const namePart = fullName.split(' (')[0];
      const infoPart = fullName.includes('(') ? `${fullName.slice(fullName.indexOf('('))}` : '';

      // 判断是否为英文名（假设英文名不包含中文字符）
      const isEnglish = /^[A-Za-z\s]+$/.test(namePart);

      // 根据是否为英文名选择不同的截断长度
      const maxLength = isEnglish ? 16: 6;

      if (namePart.length <= maxLength) {
        return fullName;
      } else {
        return `${namePart.substring(0, maxLength)}...${infoPart}`;
      }
    },

    getData() {
      this.msg = this.$t('append_field.loadingb')
      this.$ajax.post('/etv/selectDeviceTree.json').then(res => {
        this.titelData = []
        this.dataList = []
        if (res.data.code === 0) {

          this.titelData = res.data.data[0].children

          this.$nextTick(() => {
            this.showLoading = false
          })
        }
      })
    },


    deleTer(id,index) {
      Dialog.confirm({
        title: this.$t('append_field.delete_group'),
        message: this.$t('append_field.confirmDeleteGroup'),
      }).then(() => {
        this.$ajax.post('/etv//deleteGroupById.json', qs.stringify({
          id: id,
        })).then(res => {
          if (res.data.code === 0) {
            Toast(res.data.msg)
            this.titelData.splice(index, 1)
          }else {
            Toast(res.data.msg)
          }
        })
      }).catch(() => {

      })
    },

    exit(name,id) {
      this.dialogShow=true
      //去除两端的空白字符，提取分组名称
      this.groupName=trim(name.substring(0,name.indexOf('(')))
      this.id=id
      this.title=this.$t('append_field.exit_group_name')
    },

    onsubmit() {
      if(this.title===this.$t('append_field.create_terminal_group')){
        this.$ajax.post('/etv/insertGroup.json', qs.stringify({
          groupName: this.groupName,
          groupParentId: -1,
          groupDescp: '',
        })).then(res => {
          if (res.data.code === 0) {
            this.reload()
          } else {
            Toast(res.data.msg)
          }
        })
      }else {
        this.$ajax.post('/etv/updateClientNameOrGroupName.json', qs.stringify({
          name: this.groupName,
          id: this.id,
          type: "group"
        })).then(res => {
          if (res.data.code === 0) {
            this.reload()
          } else {
            Toast(res.data.msg)
          }
        })
      }

    },


    close() {
      this.show = false
      this.inputDialogClose()
    },


    inputDialogClose() {

      this.dialogShow = false
      this.show = false
      this.groupName = ''
    },
    back() {
      this.$router.back()
    }
  },
}
